'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;let

TermsController=class TermsController extends BaseController{
static get $inject(){
return['uncaughtErrorHandler','breadcrumbsService'];
}

constructor(uncaughtErrorHandler,breadcrumbsService){
super(uncaughtErrorHandler);
breadcrumbsService.startTrail('Terms of Use');
}};


module.exports=TermsController;
//# sourceMappingURL=termsController.js.map
